export enum InvoicingType {
  ByCompany = "byCompany",
  ByBroker = "byBroker",
}
